import { keyframes } from 'styled-components';

// Professional animations
export const slideInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const floatingAnimation = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-12px);
  }
`;

export const glowPulse = keyframes`
  0%, 100% {
    box-shadow: 0 0 15px rgba(255, 68, 68, 0.15);
  }
  50% {
    box-shadow: 0 0 25px rgba(255, 68, 68, 0.25);
  }
`;

export const neuralPulse = keyframes`
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(255, 68, 68, 0.4);
    border-color: rgba(255, 68, 68, 0.3);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(255, 68, 68, 0);
    border-color: rgba(255, 68, 68, 0.5);
  }
`;

export const connectedPulse = keyframes`
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.4);
    border-color: rgba(34, 197, 94, 0.3);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(34, 197, 94, 0);
    border-color: rgba(34, 197, 94, 0.5);
  }
`;

export const dashAnimation = keyframes`
  0% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: -20;
  }
`;

export const staggeredFadeIn = keyframes`
  from {
    opacity: 0;
    filter: blur(12px);
    transform: translateY(60px) scale(0.85);
  }
  to {
    opacity: 1;
    filter: blur(0px);
    transform: translateY(0) scale(1);
  }
`;

export const smoothScale = keyframes`
  from {
    transform: scale(0.96);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;

export const codeAnimation = keyframes`
  0% {
    transform: translateX(-100%) scale(0.95);
    opacity: 0;
    filter: blur(4px);
  }
  15% {
    transform: translateX(0) scale(1);
    opacity: 1;
    filter: blur(0);
  }
  85% {
    transform: translateX(0) scale(1);
    opacity: 1;
    filter: blur(0);
  }
  100% {
    transform: translateX(100%) scale(0.95);
    opacity: 0;
    filter: blur(4px);
  }
`;

export const beamAnimation = keyframes`
  0% {
    opacity: 0;
    transform: translateX(-100px) scale(0.8);
    filter: blur(2px);
  }
  50% {
    opacity: 1;
    transform: translateX(0) scale(1);
    filter: blur(0);
  }
  100% {
    opacity: 0;
    transform: translateX(100px) scale(0.8);
    filter: blur(2px);
  }
`;

export const metricPulse = keyframes`
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
`;

export const pulseGlow = keyframes`
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
`;

export const entranceFromLeft = keyframes`
  0% {
    opacity: 0;
    transform: translateX(-60px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const entranceFromRight = keyframes`
  0% {
    opacity: 0;
    transform: translateX(60px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const particleFloat = keyframes`
  0% {
    transform: translateY(0) scale(0);
    opacity: 0;
  }
  10% {
    opacity: 1;
    transform: translateY(-10px) scale(1);
  }
  90% {
    opacity: 1;
    transform: translateY(-80px) scale(1);
  }
  100% {
    transform: translateY(-100px) scale(0);
    opacity: 0;
  }
`;

export const dropdownSlideIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-8px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const dropdownSlideOut = keyframes`
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-8px);
  }
`;

export const slideInFromLeft = keyframes`
  0% {
    opacity: 0;
    transform: translateX(-60px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const slideInFromRight = keyframes`
  0% {
    opacity: 0;
    transform: translateX(60px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const slideInFromCenter = keyframes`
  0% {
    opacity: 0;
    transform: translateY(40px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const counterAnimation = keyframes`
  from {
    opacity: 0;
    transform: scale(0.5);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const progressAnimation = keyframes`
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
`;

export const shimmerAnimation = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

export const headerFadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const logoFloat = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-8px);
  }
`;

export const pulseBadge = keyframes`
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(255, 68, 68, 0.4);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(255, 68, 68, 0);
  }
`;

export const iconPop = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
`;

export const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
